/**
 * Created by ndantnarayana on 2018-09-11.
 */
import React, { Component } from 'react'
import { connect } from "react-redux";
import qs from 'query-string'
import axios from 'axios'
import { logout, initAxios, isAuthenticated } from 'helpers/api'
import Error from 'auth/Error'
import Reject from 'auth/Reject'
import { UPDATE_SESSION_STORAGE } from 'store/UserSession'
import { URL } from 'Constants'
import { Event } from 'components/Event'

class AuthWrapper extends Component {
  constructor() {
    super();
    this.state = {
      isError: false,
      isRejected: false,
      myError: {}
    };
  }

  componentDidMount() {
    if (!isAuthenticated()) {
      if (window.location.href.endsWith("logout")) {
        logout().then(() => {
          console.log("Heading to orion to logout");
          window.location = URL.ORIONLOGOUT;
        })
        .catch(error => {
            console.log("Logout call to [%s] failed: %O",URL.AUTHLOGOUT,error);
        });
      } else {
        let params = qs.parse(this.props.location.search);
        if (params.error) {
          let err = { error : params.error };
          if (params.error_description) {
            err.error_description = params.error_description;
          }
          console.log(err);
          this.setState({ isError: true, myError: err })
        } else {
          this.authenticateUser();
        }
      }
    }
  }


  authenticateUser = () => {
    const { code, ...rest } = qs.parse(this.props.location.search);
    if (code) {
      console.debug("Orion grant returned: ",code);
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: qs.stringify(rest)
      });
      Event("Login Grant", true);
      axios
        .get(URL.OAUTH_TOKEN, {
          withCredentials: true,
          params: {
            code: code,
            redirect_uri: window.location.href
          },
          header: {
            accept: "json"
          }
        })
        .then(res => {
          let resp = res.data.OrionResponse;
          initAxios(resp, res.data.SessionId);
          this.props.updateUserSession(resp);
          Event("Login Success", true);
        })
        .catch(this.handleAuthenticationErrors);
    } else {
      window.location =
        URL.ORION_OAUTH + "&redirect_uri=" + encodeURIComponent(window.location.href);
    }
  };

  handleAuthenticationErrors = err => {
    console.log("Caught: %O",err);
    if (err.status === 401 || err.status === 403) {
      //Need better error handling?
      console.error("Authentication error " + JSON.stringify(err));
      Event("Login Error",true,"AuthError " + JSON.stringify(err));
      this.setState({ isError: true, myError: err });
    } else if (err.response && err.response.status === 403) {
      this.setState({isRejected: true});
      this.props.updateUserRejected();
    } else {
      let errstr = " ";
      if (err.response && err.response.data) {
        errstr = " " + JSON.stringify(err.response.data) + " ";
      }
      Event("Login Failure",true,errstr);
      console.error("Non-401 Error thrown!%s[%O]",errstr,err);
      this.setState({ isError: true, myError: err });
    }
    throw err;
  };

  render = () => {
    if (this.state.isError) {
      return <Error {...this.props} error={this.state.myError}/>;
    } else if (this.state.isRejected) {
      return <Reject {...this.props}/>;
    }
    return this.props.children;
  };
}

const mapDispatch = dispatch => ({
  updateUserSession: orionResponse => {
    let user = orionResponse.user;
    dispatch({
      type: UPDATE_SESSION_STORAGE,
      tenantId: user.tid,
      userId: user.uuid,
      userName: user.name,
      rawUser: user,
      rejected: false
    });
  },
  updateUserRejected: () => {
    dispatch({
      type: UPDATE_SESSION_STORAGE,
      rejected: true
    });
  }
});

export default connect(
  null,
  mapDispatch
)(AuthWrapper);
